import Header from '@/components/Header';
import ChatWindow from '@/components/ChatWindow';

export default function App() {
  return (
    <div className="flex flex-col max-w-screen-md mx-auto min-h-screen bg-slate-100">
      <Header />
      <div className="flex-1">
        <ChatWindow />
      </div>
    </div>
  );
}
